import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/index';
import axios from 'axios';

Vue.use(Vuex);

// let userData = '{}';
// try {
// //   userData = JSON.parse(localStorage.getItem('userData') || '{}');
// } catch (error) {
//   console.error('Error parsing userData from localStorage:', error);
//   userData = {}; // Fallback to an empty object in case of an error
// }

export default new Vuex.Store({
  state: {
    isLoggedIn: !!localStorage.getItem('token'),
    userType: localStorage.getItem('userType'),
    idToken:localStorage.getItem('idToken'),
    uid: localStorage.getItem('uid'),
    userData: {},
    currentPage: 1,
    data: {},
    utype: null,
    menus: [],
    initial: '',
    appLoading: false,
  },
  mutations: {
    setUtype(state, utype) {
      state.utype = utype;
    },
    setData(state, payload) {
      state.data = payload;
    },
    setUserData(state, payload) {
      state.userData = payload;
    },
    setUid(state, payload) {
      state.uid = payload;
    },
    appLoading(state) {
      state.isLoading = true;
    },
    changeCurrentPage(state, item) {
      state.currentPage = item; // Update Vuex state
      localStorage.setItem("currentPage", item); // Sync with localStorage
    },
    
    sessionOut(state) {
      localStorage.removeItem('token');
      localStorage.removeItem('userData');
      localStorage.removeItem('uid');

      

      state.isLoggedIn = false;
      state.userData = {};
      state.uid = null;
      router.push('/');
    },
    logoutUser(state) {
            
      axios({
          method: "GET",
          url: "/v1/admin/auth/logout",
          headers: {
              "x-auth-token": localStorage.getItem("token")
          }
      }).then(response => {
          if (response.data) {
              state.userData = {}
              state.userRole = null
              state.isLoggedIn = false
              state.notification = 0
              localStorage.removeItem("token");
              localStorage.removeItem("uid");
              localStorage.removeItem("userData");
              // localStorage.removeItem("userType");

              if (window.location.pathname != '/') {
                  // router.push('/') 
                  router.push('/')

              }
          }
      })

      

  },
    setRole(state, item) {
      state.role = item;
    },
    loginUser(state, payload) {
      localStorage.setItem('token', payload.token);
      localStorage.setItem('userData', JSON.stringify(payload.userData));
      localStorage.setItem('uid', payload.uid);
      state.isLoggedIn = true;
      state.userData = payload.userData;
      state.uid = payload.uid;
    },
  },
  getters: {
    // currentUser: (state) => state.userData,
  },
});
